import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { render } from 'storyblok-rich-text-react-renderer';
import PostModal from '../BlogPostModal/PostModal';
import Utils from '../../services/utils';
import i18next from '../../translations/i18n';
import useWindowSize from '../../hooks/useWindowSize';
import AppTypeContext from '../../contexts/AppTypeContext';
import API from '../../services/API';

import './index.scss';

const PostBlok = ({ post }) => {
  const size = useWindowSize();
  const [showAppPostModal, setAppPostModal] = useState(false);
  const { postCreatedDate, postTitle, postDescriptionText, image } = post;
  const { filename } = image;
  const isImageOrTable = !!filename;
  const appName = useContext(AppTypeContext);

  return (
    <>
      <Col className="p-2">
        <Card
          className="flex-row flex-wrap blog"
          style={{
            maxHeight: '420px',
            minHeight: '420px',
            minWidth: `${
              isImageOrTable && size.width > 768 ? '570px' : '270px'
            }`,
          }}
          title={postTitle}
        >
          <div className="card-horizontal">
            {isImageOrTable && (
              <div className="img-square-wrapper d-none d-md-block">
                <Card.Img
                  variant="top"
                  src={filename}
                  style={{ objectFit: 'cover' }}
                  className="img-fluid img-container"
                />
              </div>
            )}
            <Card.Body
              className={`p-0 card-body-text my-4 me-4 ${
                isImageOrTable ? 'ms-3' : 'ms-4'
              }`}
            >
              <Card.Text className="mb-4 text-muted card-date-text">
                {postCreatedDate ? Utils.formatDate(postCreatedDate) : ''}
              </Card.Text>
              <Card.Title className="text-truncate-heading mb-4 card-post-title">
                <div className="card-post-title">{postTitle}</div>
              </Card.Title>
              <Card.Text as="div" className="block-with-text p-0 m-0">
                <div className="text-truncate-container">
                  {render(postDescriptionText)}
                </div>
              </Card.Text>
              <Card.Link
                className="mt-auto stretched-link card-link-text d-inline-flex post-link-card more-details"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  API.sendToGA(
                    postTitle
                      ? `${appName}-${postTitle}`
                      : `${appName}`,
                  );
                  setAppPostModal(true);
                }}
                name={postTitle}
                title={`${i18next.t('clickToView')} ${postTitle}`}
              >
                {i18next.t('moreDetails')} »
              </Card.Link>
            </Card.Body>
          </div>
        </Card>
      </Col>
      {showAppPostModal && (
        <PostModal
          onHide={() => setAppPostModal(false)}
          post={post}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            setAppPostModal(false);
          }}
        />
      )}
    </>
  );
};

PostBlok.propTypes = {
  post: PropTypes.shape({
    postCreatedDate: PropTypes.string.isRequired,
    postTitle: PropTypes.string.isRequired,
    postDescriptionText: PropTypes.shape({}).isRequired,
    image: PropTypes.shape({
      filename: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default PostBlok;
